import { createStackNavigator } from '@react-navigation/stack'
import QRcodeV2 from '../../screens/QRcodeV2'

const QrStack = () => {
  const Stack = createStackNavigator()
  return (
    <Stack.Navigator
      screenOptions={{ headerBackTitleVisible: false, headerShown: false, headerMode: 'screen' }}
      initialRouteName={'staticQr'}>
      <Stack.Screen name="staticQr" component={QRcodeV2} />
    </Stack.Navigator>
  )
}

export default QrStack
